import { render, staticRenderFns } from "./gpt_classify.vue?vue&type=template&id=2dad7186"
import script from "./gpt_classify.vue?vue&type=script&lang=js"
export * from "./gpt_classify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports